import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import {
  IVerifoneTerminal,
  VerifoneTransactionType,
} from '@principle-theorem/principle-core/interfaces';

const TRANSACTION_TYPE_LABELS: Record<VerifoneTransactionType, string> = {
  [VerifoneTransactionType.Purchase]: 'Purchase',
  [VerifoneTransactionType.Refund]: 'Refund',
};

export interface IVerifoneTransactionDialogData {
  type: VerifoneTransactionType;
  amount: number;
  terminal: Pick<IVerifoneTerminal, 'name' | 'uid'>;
}

export interface IVerifoneTransactionDialogResult {
  cancelled: boolean;
}

@Component({
  selector: 'pr-verifone-transaction-dialog',
  imports: [NgDialogModule, MatProgressSpinnerModule],
  templateUrl: './verifone-transaction-dialog.component.html',
  styleUrls: ['./verifone-transaction-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifoneTransactionDialogComponent {
  typeLabel: string;

  constructor(
    public dialogRef: MatDialogRef<
      VerifoneTransactionDialogComponent,
      IVerifoneTransactionDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: IVerifoneTransactionDialogData
  ) {
    dialogRef.disableClose = true;
    this.typeLabel = TRANSACTION_TYPE_LABELS[data.type];
  }

  cancel(): void {
    this.dialogRef.close({ cancelled: true });
  }
}
